import React, { useContext, useEffect, useState } from "react";
import "./Product.css";
import Category from "../Category/Category";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { RotatingLines } from "react-loader-spinner";
import { cartContext } from "../../context/Car/CarContext";
import toast from "react-hot-toast";
import { StoreContext } from "../../context/StoreContext/StoreContext";
import { Helmet } from "react-helmet";

export default function Products() {
  // let {counter, setcounter}=useContext(StoreContext)

  const location = useLocation();
  let navigate = useNavigate();
  const searchResults = location.state?.searchResults || [];
  const categoryProduct = location.state?.products || [];
  let { addToCart } = useContext(cartContext);
  const headers = {
    token: localStorage.getItem("userToken"),
  };
  let [cardata, setcardata] = useState([]);
  let [logproduct, setlogproduct] = useState([]);

  async function addProduct(productId) {
    let response = await addToCart(productId);
    console.log(response);
    if (localStorage.getItem("userToken") === null) {
      navigate("/login");
      toast.error("Error adding product,You Must login");
    } else if (response.data.message === "Item(s) added to cart.") {
      toast.success("product successfully Added", {
        duration: 3000,
        position: "top-center",
      });
    } else {
      toast.error("Error adding product");
    }
  }

  function getAllProducts() {
    return axios.get(
      "https://vehex-production.up.railway.app/product/getAllProducts"
    );
  }
  async function getAllProductsForLoggedUsers() {
    try {
      const response = await axios.get(
        "https://vehex-production.up.railway.app/product/loggedUserProducts",
        { headers }
      );
      // console.log(response)

      if (response?.data?.products?.length > 0) {
        setlogproduct(response.data.products);
      } else {
        console.warn("No products found for the logged-in user.");
      }
    } catch (error) {
      console.error(
        "Error fetching products for logged user:",
        error.response?.status,
        error.response?.data || error.message
      );
    }
  }
  useEffect(() => {
    getAllProductsForLoggedUsers();
  }, []);

  let { isLoading, isError, data } = useQuery(
    "featureProducts",
    getAllProducts
  );
  // console.log(data)
  async function getUserCarBydata() {
    let response = await axios.get(
      "https://vehex-production.up.railway.app/car/userCars",
      {
        headers,
      }
    );
    // console.log(response);
    setcardata(response?.data.cars);
  }
  useEffect(() => {
    getUserCarBydata();
  }, []);

  return (
    <>
      <Helmet>
        <title>Products</title>
      </Helmet>
      <div className="product d-flex justify-content-between">
        <Category />

        {isLoading ? (
          <div className="position-fixed top-50 start-50 translate-middle">
            <RotatingLines
              strokeColor="green"
              strokeWidth="5"
              animationDuration="1"
              width="85"
              visible={true}
            />
          </div>
        ) : (
          <>
            {searchResults.length > 0 ? (
              <section className="container right-section flex-fill py-4">
                <h2 className="heading mx-3 fw-500">
                  Products For Your Search
                </h2>

                <div className="allProduct d-grid p-3">
                  {searchResults.map((product) => (
                    <div className="box" key={product._id}>
                      <Link to={`/productDetails/${product._id}`}>
                        <div className="productImg">
                          <img
                            src={product.image[0]?.secure_url}
                            alt={product.name}
                            className="w-100"
                            height={150}
                          />
                        </div>

                        <div className="productInfo text-center">
                          <p className="productTitle fs-6 main-color fw-500 m-0">
                            {product.name.split(" ").slice(0, 3).join(" ")}
                          </p>
                          <p className="description fs-6 m-0 text-black">
                            {product.description
                              .split(" ")
                              .slice(0, 3)
                              .join(" ")}
                          </p>
                          <p className="price main-color fs-6 m-0">
                            Price:{" "}
                            <span className="text-black">
                              {product.price} SAR
                            </span>
                          </p>
                        </div>
                      </Link>
                      <button
                        onClick={() => {
                          addProduct(product._id);
                        }}
                        className="bg-main-color w-100 mt-2 text-white"
                      >
                        Add To Cart <i class="fa-solid fa-cart-shopping"></i> 
                      </button>
                    </div>
                  ))}
                </div>
              </section>
            ) : categoryProduct.length > 0 ? (
              <section className="container right-section flex-fill py-4">
                <h2 className="heading mx-3 fw-500">
                  Products in The Selected Category
                </h2>
                <div className="allProduct d-grid p-3">
                  {categoryProduct.map((product) => (
                    <div className="box" key={product._id}>
                      <Link to={`/productDetails/${product._id}`}>
                        <div className="productImg">
                          <img
                            src={product.image[0]?.secure_url}
                            alt={product.name}
                            className="w-100"
                            height={150}
                          />
                        </div>
                        <div className="productInfo text-center">
                          <p className="productTitle fs-6 main-color fw-500 m-0">
                            {product.name.split(" ").slice(0, 3).join(" ")}
                          </p>
                          <p className="description fs-6 m-0 text-black">
                            {product.description
                              .split(" ")
                              .slice(0, 3)
                              .join(" ")}
                          </p>
                          <p className="price main-color fs-6 m-0">
                            Price:{" "}
                            <span className="text-black">
                              {product.price} SAR
                            </span>
                          </p>
                        </div>
                      </Link>
                      <button
                        onClick={() => {
                          addProduct(product._id);
                        }}
                        className="bg-main-color w-100 mt-2 text-white"
                      >
                        Add To Cart <i class="fa-solid fa-cart-shopping"></i> 
                      </button>
                    </div>
                  ))}
                </div>
              </section>
            ) : cardata?.length > 0 && logproduct?.length > 0 ? (
              <section className="container right-section flex-fill py-4">
                <h2 className="heading mx-3 fw-500">Products For Your Cars</h2>
                <div className="allProduct d-grid p-3">
                  {logproduct.map((product) => (
                    <div className="box" key={product._id}>
                      <Link to={`/productDetails/${product._id}`}>
                        <div className="productImg">
                          <img
                            src={product.image[0].secure_url}
                            alt={product.name}
                            className="w-100"
                            height={150}
                          />
                        </div>
                        <div className="productInfo text-center">
                          <p className="productTitle fs-6 main-color fw-500 m-0">
                            {product.name.split(" ").slice(0, 3).join(" ")}
                          </p>
                          <p className="description fs-6 m-0 text-black">
                            {product.description
                              .split(" ")
                              .slice(0, 3)
                              .join(" ")}
                          </p>
                          <p className="price main-color fs-6 m-0">
                            Price:{" "}
                            <span className="text-black">
                              {product.price} SAR
                            </span>
                          </p>
                        </div>
                      </Link>
                      <button
                        onClick={() => {
                          addProduct(product._id);
                        }}
                        className="bg-main-color w-100 mt-2 text-white"
                      >
                        Add To Cart <i class="fa-solid fa-cart-shopping"></i> 
                      </button>
                    </div>
                  ))}
                </div>
              </section>
            ) : (
              <section className="container right-section flex-fill py-4">
                <h2 className="heading mx-3 fw-500">All Products</h2>
                <div className="allProduct d-grid p-3">
                  {data?.data.products.map((product) => (
                    <div className="box" key={product._id}>
                      <Link to={`/productDetails/${product._id}`}>
                        <div className="productImg">
                          <img
                            src={product.image[0].secure_url}
                            alt={product.name}
                            className="w-100"
                            height={150}
                          />
                        </div>
                        <div className="productInfo text-center">
                          <p className="productTitle fs-6 main-color fw-500 m-0">
                            {product.name.split(" ").slice(0, 3).join(" ")}
                          </p>
                          <p className="description fs-6 m-0 text-black">
                            {product.description
                              .split(" ")
                              .slice(0, 3)
                              .join(" ")}
                          </p>
                          <p className="price main-color fs-6 m-0">
                            Price:{" "}
                            <span className="text-black">
                              {product.price} SAR
                            </span>
                          </p>
                        </div>
                      </Link>
                      <button
                        onClick={() => {
                          addProduct(product._id);
                        }}
                        className="bg-main-color w-100 mt-2 text-white"
                      >
                        Add To Cart <i class="fa-solid fa-cart-shopping"></i> 
                      </button>
                    </div>
                  ))}
                </div>
              </section>
            )}
          </>
        )}
      </div>
    </>
  );
}
